import * as bootstrap from "bootstrap";
import observeStickyElement from "./stickyStuck";
import onReady from "./onReady";
import AOS from "aos";
import "fslightbox";

const componentModules = import.meta.glob(
	"../../site/templates/components/**/*.js",
);

const componentModuleByName = Object.entries(componentModules).reduce(
	(index, [modulePath, loader]) => {
		const fileName = modulePath.split("/").pop();
		if (!fileName || !fileName.endsWith(".js")) return index;

		const componentName = fileName.replace(/\.js$/, "");
		index[componentName] = loader;
		return index;
	},
	{},
);

function loadComponentScripts() {
	const componentNames = new Set(
		Array.from(document.querySelectorAll("[data-component]"))
			.map((element) => element.getAttribute("data-component"))
			.filter(Boolean),
	);

	componentNames.forEach((componentName) => {
		const loader = componentModuleByName[componentName];
		if (loader) loader();
	});
}

onReady(function () {
	AOS.init({
		easing: "ease-in-out",
		offset: 50,
	});

	observeStickyElement();
	loadComponentScripts();
});
